const defaultGamerProfile = {
  achievementSoundsEnabled: true,
  averageAccuracy: 0,
  'counter-strike-global-offensive': {
    ak47HighScore: 0,
    ak47PlayCount: 0,
    augHighScore: 0,
    augPlayCount: 0,
    averageScore: 0,
    famasHighScore: 0,
    famasPlayCount: 0,
    galilarHighScore: 0,
    galilarPlayCount: 0,
    highScore: 0,
    m4a1sHighScore: 0,
    m4a1sPlayCount: 0,
    m4a4HighScore: 0,
    m4a4PlayCount: 0,
    playCount: 0,
    rifleHighScore: 0,
    riflePlayCount: 0,
    sg553HighScore: 0,
    sg553PlayCount: 0,
    totalScore: 0,
    unlimited: true,
  },
  custom: {
    acceleration: 0,
    averageAccuracy: 0,
    averageMissCount: 0,
    averageMissedTargetCount: 0,
    averageScaleSpeed: 0,
    averageScore: 0,
    averageSpeed: 0,
    averageTargetCount: 0,
    averageTimeToHit: 0,
    goal: 60,
    goalType: 'time',
    highScore: 0,
    longestHitStreak: 0,
    moving: true,
    movingLearning: true,
    multiple: true,
    playCount: 0,
    scale: 0.3,
    scalePlayCount: 0,
    scaleSpeedPlayCount: 0,
    scaleSpeed: 0.005,
    scaling: true,
    scalingLearning: true,
    scorePlayCount: 0,
    speed: 1,
    speedPlayCount: 0,
    topAccuracy: 0,
    topMissCount: 0,
    topMissedTargetCount: 0,
    topScaleSpeed: 0.005,
    topSpeed: 1,
    topTargetCount: 0,
    totalMissCount: 0,
    totalMissedTargetCount: 0,
    totalScaleSpeed: 0,
    totalScore: 0,
    totalSpeed: 0,
    totalTargetCount: 0,
    totalTimeToHit: 0,
    unlimited: false,
  },
  flick: {
    acceleration: 0,
    averageAccuracy: 0,
    averageMissCount: 0,
    averageMissedTargetCount: 0,
    averageScaleSpeed: 0,
    averageTargetCount: 0,
    averageTimeToHit: 0,
    goal: 60,
    goalType: 'time',
    highScore: 0,
    longestHitStreak: 0,
    playCount: 0,
    scale: 0.3,
    scaleSpeed: 0.005,
    speed: 1,
    topAccuracy: 0,
    topMissCount: 0,
    topMissedTargetCount: 0,
    topScaleSpeed: 0.005,
    topSpeed: 1,
    topTargetCount: 0,
    totalMissCount: 0,
    totalMissedTargetCount: 0,
    totalScaleSpeed: 0,
    totalTargetCount: 0,
    totalTimeToHit: 0,
  },
  'follow-through': {
    acceleration: 0,
    averageAccuracy: 0,
    averageMissCount: 0,
    averageScore: 0,
    averageSpeed: 0,
    averageTargetCount: 0,
    averageTimeToHit: 0,
    highScore: 0,
    longestHitStreak: 0,
    playCount: 0,
    scaleSpeed: 0.005,
    speed: 1,
    topAccuracy: 0,
    topMissCount: 0,
    topMissedTargetCount: 0,
    topScaleSpeed: 0.005,
    topSpeed: 1,
    topTargetCount: 0,
    totalMissCount: 0,
    totalMissedTargetCount: 0,
    totalScore: 0,
    totalSpeed: 0,
    totalTargetCount: 0,
    totalTimeToHit: 0,
  },
  highScore: 0,
  learning: {
    moving: {
      acceleration: 0,
      averageAccuracy: 0,
      averageMissCount: 0,
      averageScore: 0,
      averageTargetCount: 0,
      averageTimeToHit: 0,
      goal: 10,
      goalType: 'time',
      highScore: 0,
      longestHitStreak: 0,
      playCount: 0,
      scale: 1,
      scaleSpeed: 0.005,
      speed: 0.2,
      topAccuracy: 0,
      topMissCount: 0,
      topMissedTargetCount: 0,
      topScaleSpeed: 0.005,
      topSpeed: 0.2,
      topTargetCount: 0,
      totalMissCount: 0,
      totalMissedTargetCount: 0,
      totalScore: 0,
      totalTargetCount: 0,
      totalTimeToHit: 0,
    },
    scaling: {
      acceleration: 0,
      averageAccuracy: 0,
      averageMissCount: 0,
      averageMissedTargetCount: 0,
      averageScore: 0,
      averageTargetCount: 0,
      averageTimeToHit: 0,
      goal: 10,
      goalType: 'time',
      highScore: 0,
      longestHitStreak: 0,
      playCount: 0,
      scale: 0.3,
      scaleSpeed: 0.005,
      speed: 0.2,
      topAccuracy: 0,
      topMissCount: 0,
      topMissedTargetCount: 0,
      topScaleSpeed: 0.005,
      topSpeed: 0.2,
      topTargetCount: 0,
      totalMissCount: 0,
      totalMissedTargetCount: 0,
      totalScore: 0,
      totalTargetCount: 0,
      totalTimeToHit: 0,
    },
    stationary: {
      acceleration: 0,
      averageAccuracy: 0,
      averageMissCount: 0,
      averageScore: 0,
      averageTargetCount: 0,
      averageTimeToHit: 0,
      goal: 10,
      goalType: 'time',
      highScore: 0,
      longestHitStreak: 0,
      playCount: 0,
      scale: 1,
      scaleSpeed: 0.005,
      speed: 0.2,
      topAccuracy: 0,
      topMissCount: 0,
      topMissedTargetCount: 0,
      topScaleSpeed: 0.005,
      topSpeed: 0.2,
      topTargetCount: 0,
      totalMissCount: 0,
      totalMissedTargetCount: 0,
      totalScore: 0,
      totalTargetCount: 0,
      totalTimeToHit: 0,
    },
  },
  longestHitStreak: 0,
  mouseoverOverlay: true,
  'net-train': {
    acceleration: 0,
    averageAccuracy: 0,
    averageMissCount: 0,
    averageScore: 0,
    averageTargetCount: 0,
    averageTimeToHit: 0,
    goal: 60,
    goalType: 'time',
    highScore: 0,
    longestHitStreak: 0,
    playCount: 0,
    scale: 0.3,
    scaleSpeed: 0.005,
    speed: 1,
    topAccuracy: 0,
    topMissCount: 0,
    topMissedTargetCount: 0,
    topScaleSpeed: 0.005,
    topSpeed: 1,
    topTargetCount: 0,
    totalMissCount: 0,
    totalMissedTargetCount: 0,
    totalScore: 0,
    totalTargetCount: 0,
    totalTimeToHit: 0,
  },
  playCount: 0,
  practice: {
    benchmark: {
      acceleration: 0,
      averageAccuracy: 0,
      averageMissCount: 0,
      averageScore: 0,
      averageTargetCount: 0,
      averageTimeToHit: 0,
      goal: 60,
      goalType: 'time',
      highScore: 0,
      longestHitStreak: 0,
      playCount: 0,
      scale: 1,
      scaleSpeed: 0.005,
      speed: 1,
      topAccuracy: 0,
      topMissCount: 0,
      topMissedTargetCount: 0,
      topScaleSpeed: 0.005,
      topSpeed: 1,
      topTargetCount: 0,
      totalMissCount: 0,
      totalMissedTargetCount: 0,
      totalScore: 0,
      totalTargetCount: 0,
      totalTimeToHit: 0,
    },
    moving: {
      acceleration: 0,
      averageAccuracy: 0,
      averageMissCount: 0,
      averageSpeed: 0,
      averageTargetCount: 0,
      averageTimeToHit: 0,
      goal: 60,
      goalType: 'time',
      highScore: 0,
      longestHitStreak: 0,
      playCount: 0,
      scale: 1,
      scaleSpeed: 0.005,
      speed: 1,
      topAccuracy: 0,
      topMissCount: 0,
      topMissedTargetCount: 0,
      topScaleSpeed: 0.005,
      topSpeed: 1,
      topTargetCount: 0,
      totalMissCount: 0,
      totalMissedTargetCount: 0,
      totalSpeed: 0,
      totalTargetCount: 0,
      totalTimeToHit: 0,
    },
    multiple: {
      acceleration: 0,
      averageAccuracy: 0,
      averageMissCount: 0,
      averageScore: 0,
      averageTargetCount: 0,
      averageTimeToHit: 0,
      goal: 60,
      goalType: 'time',
      highScore: 0,
      longestHitStreak: 0,
      playCount: 0,
      scale: 1,
      scaleSpeed: 0.005,
      speed: 1,
      topAccuracy: 0,
      topMissCount: 0,
      topMissedTargetCount: 0,
      topScaleSpeed: 0.005,
      topSpeed: 1,
      topTargetCount: 0,
      totalMissCount: 0,
      totalMissedTargetCount: 0,
      totalScore: 0,
      totalTargetCount: 0,
      totalTimeToHit: 0,
    },
    scaling: {
      acceleration: 0,
      averageAccuracy: 0,
      averageMissCount: 0,
      averageMissedTargetCount: 0,
      averageScaleSpeed: 0,
      averageTargetCount: 0,
      averageTimeToHit: 0,
      goal: 60,
      goalType: 'time',
      highScore: 0,
      longestHitStreak: 0,
      playCount: 0,
      scale: 0.3,
      scaleSpeed: 0.005,
      speed: 1,
      topAccuracy: 0,
      topMissCount: 0,
      topMissedTargetCount: 0,
      topScaleSpeed: 0.005,
      topSpeed: 1,
      topTargetCount: 0,
      totalMissCount: 0,
      totalMissedTargetCount: 0,
      totalScaleSpeed: 0,
      totalTargetCount: 0,
      totalTimeToHit: 0,
    },
  },
  ranked: {
    acceleration: 0,
    averageAccuracy: 0,
    averageMissCount: 0,
    averageMissedTargetCount: 0,
    averageScaleSpeed: 0,
    averageSpeed: 0,
    averageTargetCount: 0,
    averageTimeToHit: 0,
    goal: 60,
    goalType: 'time',
    highScore: 0,
    longestHitStreak: 0,
    playCount: 0,
    scale: 0.3,
    scaleSpeed: 0.005,
    speed: 1,
    topAccuracy: 0,
    topMissCount: 0,
    topMissedTargetCount: 0,
    topScaleSpeed: 0.005,
    topSpeed: 1,
    topTargetCount: 0,
    totalMissCount: 0,
    totalMissedTargetCount: 0,
    totalScaleSpeed: 0,
    totalSpeed: 0,
    totalTargetCount: 0,
    totalTimeToHit: 0,
  },
  scalePlayCount: 0,
  scaleSpeedPlayCount: 0,
  scorePlayCount: 0,
  soundEnabled: true,
  speed: {
    acceleration: 0,
    averageAccuracy: 0,
    averageMissCount: 0,
    averageScore: 0,
    averageTargetCount: 0,
    averageTimeToHit: 0,
    goal: 60,
    goalType: 'time',
    highScore: 0,
    longestHitStreak: 0,
    playCount: 0,
    scale: 1,
    scaleSpeed: 0.005,
    speed: 1,
    topAccuracy: 0,
    topMissCount: 0,
    topMissedTargetCount: 0,
    topScaleSpeed: 0.005,
    topSpeed: 1,
    topTargetCount: 0,
    totalMissCount: 0,
    totalMissedTargetCount: 0,
    totalScore: 0,
    totalTargetCount: 0,
    totalTimeToHit: 0,
  },
  speedPlayCount: 0,
  topAccuracy: 0,
  topMissCount: 0,
  topMissedTargetCount: 0,
  topScaleSpeed: 0.005,
  topSpeed: 1,
  topTargetCount: 0,
  totalMissCount: 0,
  totalMissedTargetCount: 0,
  totalScaleSpeed: 0,
  totalScore: 0,
  totalSpeed: 0,
  totalTargetCount: 0,
  totalTimeToHit: 0,
  tour: {
    initialDialogShown: false,
  },
  tracking: {
    acceleration: 0,
    averageAccuracy: 0,
    averageMissCount: 0,
    averageSpeed: 0,
    averageTargetCount: 0,
    averageTimeToHit: 0,
    goal: 60,
    goalType: 'time',
    highScore: 0,
    longestHitStreak: 0,
    playCount: 0,
    scale: 1,
    scaleSpeed: 0.005,
    speed: 1,
    topAccuracy: 0,
    topMissCount: 0,
    topMissedTargetCount: 0,
    topScaleSpeed: 0.005,
    topSpeed: 1,
    topTargetCount: 0,
    totalMissCount: 0,
    totalMissedTargetCount: 0,
    totalSpeed: 0,
    totalTargetCount: 0,
    totalTimeToHit: 0,
  },
  'zig-zag': {
    acceleration: 0,
    averageAccuracy: 0,
    averageMissCount: 0,
    averageScore: 0,
    averageSpeed: 0,
    averageTargetCount: 0,
    averageTimeToHit: 0,
    highScore: 0,
    longestHitStreak: 0,
    playCount: 0,
    scaleSpeed: 0.005,
    speed: 1,
    topAccuracy: 0,
    topMissCount: 0,
    topMissedTargetCount: 0,
    topScaleSpeed: 0.005,
    topSpeed: 1,
    topTargetCount: 0,
    totalMissCount: 0,
    totalMissedTargetCount: 0,
    totalScore: 0,
    totalSpeed: 0,
    totalTargetCount: 0,
    totalTimeToHit: 0,
  },
}

const defaultGamerPurchaseProfile = {

}

export { defaultGamerProfile, defaultGamerPurchaseProfile, }



// WEBPACK FOOTER //
// ./src/app/const/gamerProfiles.js